import { atom } from "recoil";

export const uploadFileAtom = atom({
  key: "upload-file",
  default: {
    preUploadStatus: "initial", uploadStatus: "initial", controller: undefined,
  },
});
